import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Verified = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const sessionId = urlParams.get('session_id');
                if (!sessionId) {
                    console.error('Session ID not found');
                    return;
                }
                fetch(`/api/clearme/verified/${sessionId}`).then((response) => {
                    if (!response.ok) throw new Error(response.statusText);
                })
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchData();
    }, []);


    const handleGoBack = () => {
        navigate('/');
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <div>
                <h1>Clearme Verification Completed!</h1>
                <p>Congratulations! You have successfully completed the Clearme verification process.</p>
                <Button variant="contained" color="primary" onClick={handleGoBack}>Go Back</Button>
            </div>
        </div>
    );
};

export default Verified;